/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Thumbnail } from './Thumbnail';

export type Material = {
    id: string;
    title: string;
    description: string;
    thumbnail: Thumbnail;
    orderCode: string;
    priceType: Material.priceType;
    pricePerUnit: string;
    ghMaterialJson: string;
    materialTypeId: string;
    materialFolderId: string;
    isVisible: boolean;
    verticalSidingId?: string;
}

export namespace Material {

    export enum priceType {
        FIXED = 'FIXED',
        SQ_FT_ = 'SQ. FT.',
        LINEAR_FT_ = 'LINEAR FT.',
        WALL_AREA = 'WALL AREA',
    }


}
